export const isCartBarAvailable = (path) => {
  if (path === "/") return true;
  if (path.startsWith("/detail/")) return true;
  // if (path.startsWith("/profile")) return true;
  // if (path.startsWith("/contact")) return true;
  return false;
};
export const isCategoryAvailable = (path) => {
  if (path === '/') return true;
}